export default __webpack_public_path__ + "static/media/single-project-page-04-img13.c95c802b.png";